

















































































































import Vue from 'vue';
import store from '@/store';
import {
  GroupBuilder,
  GroupBuilderKind,
  GoalsType,
  PacketInfo,
  CreationProcess
} from '@/store/getStarted';

import CogsDefinition from '@/components/widgets/CogsDefinition.vue';
import CreationProcessProgress from '@/components/getStarted/CreationProcessProgress.vue';
import GetStartedNav from '@/components/getStarted/GetStartedNav.vue';
import PacketCard from '@/components/PacketCard.vue';

export default Vue.extend({
  components: {
    CogsDefinition,
    CreationProcessProgress,
    GetStartedNav,
    PacketCard
  },

  computed: {
    user(): firebase.User | null {
      return store.state.getStarted.firebaseUser;
    },

    orgName(): string {
      return store.state.getStarted.orgName;
    },

    scholarship(): boolean {
      return store.state.getStarted.accountType.toLowerCase() === 'scholarship';
    },

    groupBuilder(): GroupBuilder {
      return store.state.getStarted.groupBuilder;
    },

    isGoogleClassroom(): boolean {
      return this.groupBuilder.kind === GroupBuilderKind.GOOGLE_CLASSROOM;
    },

    isManualGroup(): boolean {
      return !this.isGoogleClassroom;
    },

    goalsType(): GoalsType {
      return store.state.getStarted.goalsType;
    },

    selectedPacketInfos(): PacketInfo[] {
      return store.state.getStarted.publicPacketOptions
        .filter(([, , selected]) => selected)
        .map(([p, b]) => [p, b]);
    },

    builtPacketInfo(): PacketInfo | null {
      return store.state.getStarted.newPacket;
    },

    packetInfos(): PacketInfo[] {
      if (this.goalsType === GoalsType.PUBLIC) {
        return this.selectedPacketInfos;
      }

      if (this.builtPacketInfo) {
        return [this.builtPacketInfo];
      }

      return [];
    },

    creationProcess(): CreationProcess {
      return store.state.getStarted.creationProcess;
    },

    showProgress(): boolean {
      return this.creationProcess.isInProgress;
    }
  },

  methods: {
    getStarted() {
      store.dispatch.getStarted.create();
    }
  }
});
